import DateSelector from '../../common/dateSelector'
import SelectDropDown from '../../common/selectDropDown'
import TextInput from '../../common/textInput'
import { Toggle } from '../../common/toggle'

export const formComponentMap = {
  text: {
    component: TextInput,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'name',
      label: 'name',
      code: 'code',
    },
    propValues: {
      type: 'text',
      noIconPadding: true,
    },
  },
  number: {
    component: TextInput,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
    },
    propValues: {
      type: 'number',
      keyboardType: 'number-pad',
    },
  },
  toggle: {
    component: Toggle,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      fieldOptions: 'fieldOptions',
    },
  },
  dropdown: {
    component: SelectDropDown,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      options: 'fieldOptions',
    },
  },
  search: {
    component: SelectDropDown,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      options: 'fieldOptions',
      fieldId: 'id',
    },
    propValues: {
      isSearchable: true,
    },
  },
  date: {
    component: DateSelector,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      label: 'name',
    },
  },
}
